import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {extendRules} from '@/form-validation/utils/vee-validation-rules-extension';

export default function install(Vue) {
  Vue.component('validation-provider', ValidationProvider);
  Vue.component('validation-observer', ValidationObserver);

  extendRules();
}
